import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getActiveCompanyId } from '../utils/companyContext';

const ProtectedRoute = () => {
  const location = useLocation();
  const token = localStorage.getItem('authToken');
  const activeCompanyId = getActiveCompanyId();
  const isCompanySelectionPath = location.pathname.startsWith('/select-company');
  const isLogoutPath = location.pathname === '/logout';

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!activeCompanyId && !isCompanySelectionPath && !isLogoutPath) {
    return <Navigate to="/select-company" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
